import React from "react"
import styled, { css, withTheme } from "styled-components"

import { margin } from "../../common/styledHelpers"

const Container = styled.div`
  display: flex;
  ${margin}
  transform: rotate(${props => props.rotation || 0});
  ${props => props.center
    ? css`
      display: flex;
      align-items: center;`
    : ""
  };
  ${props => props.small
    ? css`
      width: 11px;
      height: 5px;
      stroke-width: 2px;`
    : ""
  };
`

const Arrow = ({ color, theme, ...props }) => (
  <Container {...props}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width ? props.width : "18"}
      height={props.height ? props.height : "10"}
      viewBox="0 0 18 10"
    >
      <path
        fill="none"
        fillRule="evenodd"
        stroke={color ? theme.colors[color] : theme.colors.primary}
        d="M0 1l9.052 8L18 1"
      />
    </svg>
  </Container>
)

export default withTheme(Arrow)



// WEBPACK FOOTER //
// ./assets/completion/images/Arrow.js